import AgGridWrapper from "../../../../../components/AgGridWrapper/AgGridWrapper";
import ActionButtons from "../../../../../components/ActionButtons";
import { setGrid } from "../../utils/slice";
import { useAppSelector } from "../../../../../utils/hooks/hooks";
import { useState } from "react";
import useColumnDefs from "./columnDefs";
import { RootState } from "../../../../../store/app";
import React from "react";

const Listing: React.FC<any> = ({
  moduleInfo,
  handleViewClick,
}) => {

  const columnDefs = useColumnDefs;
  const experience = useAppSelector((state: RootState) => state.importActivity);
  const [statusData, setStatusData] = useState<any>();

  const ActionRenderer = (props: any) => {
    return (
      <ActionButtons
        data={props}
        view={{
          action: handleViewClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_DETAILS`,
        }}
      />
    );
  };

  return (
    <>
      <AgGridWrapper
        components={{
          ActionRenderer,
        }}
        rowData={experience.rowData}
        onGridReadyWithDispatch={setGrid}
        columnDefs={columnDefs}
        context={{ setStatusData }}
        paginationPageSize={experience.perPage}
        cacheBlockSize={experience.perPage}
      />
    </>
  );
};

export default Listing;
